import { Controller } from '@hotwired/stimulus';
import * as IIFEPagy from '../../../vendor/javascript/pagy/pagy.min.js';

export default class extends Controller {
  connect() {
    Pagy.init(this.element);
  }
}
